import { jsx } from "react/jsx-runtime";
import ProratedRentCalculator from "@zg-rentals/rg-widgets-rent-calc";
const ProratedRentCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      itc,
      t
    } = attrs;
    const defaultValues = {
      itc,
      t
    };
    return /* @__PURE__ */ jsx(ProratedRentCalculator, { ...defaultValues });
  },
  metadata: {
    version: "1.0",
    name: "zg-rentals/rg-widgets-rent-calc",
    title: "Prorated Rent Calculator",
    description: "Calculate the prorated rent for a rental property.",
    icon: "calculator",
    keywords: ["rental", "prorate", "calculator"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "calculators",
    attributes: {
      itc: {
        type: "string"
      },
      t: {
        type: "string"
      }
    }
  }
};
export {
  ProratedRentCalculatorBlock as default
};
